
<snl-modal class="CommnModalChanges EditorMdl" (modalClose)="closeModalPopUp()" [type]="'medium'" [open]="open" [settings]="modalSettings"> 
    <div slot="heading">CCD# {{ccdNo}} - Management notes</div> 
    <div class="EditorMdlBody" slot="modalContent">
        <app-notes [accessOfNotesEditor]="accessOfNotesEditor" [selectedTab]="selectedTab" [ccdNo]="ccdNo" [from]="'notesPopup'"></app-notes>
    </div> 
</snl-modal>